import * as React from "react";
import { IconProps } from "./types";

export const Recording02Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M3 10L3 14M7.5 11V13M12 6V18M16.5 3V21M21 10V14"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(Recording02Icon as React.FunctionComponent).displayName = "Recording02Icon";

export default Recording02Icon;
